import { Fragment, useContext } from 'react'
import { StepList, StepLabel, StepBox, Header, Heading } from './style'
import { Container, Grid, Paper } from '@material-ui/core'
import Logo from 'src/walliro/assets/images/default/logo.png'
import { useStepper } from './stepperContext'
import { Button } from 'react-bootstrap'
import { SafeListSidebarContext } from '../SafeListSidebar'
import { Link } from 'react-router-dom'
const StepperHeader = () => {
  const { currentStep, setCurrentStep, steps } = useStepper()
  const { toggleSidebar } = useContext(SafeListSidebarContext)
  return (
    <Fragment>
      <Header $bgUri={'/images/walliro-bg.png'}>
        <Container maxWidth="xl">
          <Grid container>
            <Grid item container lg={4} xs={12} className="mb-3 mt-5">
              <Grid item>
                <Link to={'/'}>
                  <img src={Logo} alt="walliro" />
                </Link>
              </Grid>
              <Grid item>
                <Button
                  variant="shadow"
                  className={'btn-icon fixed btn-circle ms-auto ms-lg-4'}
                  onClick={toggleSidebar}
                >
                  <i className="material-icons">east</i>
                </Button>
              </Grid>
            </Grid>
            <Grid item lg={4} xs={12} className="mb-5 mt-3">
              <Heading className="p-3">
                <h1>{steps[currentStep].props.label}</h1>
              </Heading>
            </Grid>
          </Grid>
        </Container>
        <StepList>
          {steps.map((_, index) => {
            const isStepLabelClickable = currentStep > index
            function onClickLabel() {
              if (isStepLabelClickable) {
                setCurrentStep(index)
              }
            }

            return (
              <StepBox key={index} $isActive={index <= currentStep}>
                <StepLabel disabled={currentStep <= index} onClick={onClickLabel}>
                  {index + 1}
                </StepLabel>
              </StepBox>
            )
          })}
        </StepList>
      </Header>
    </Fragment>
  )
}

export default StepperHeader
